import { createDeepEqualSelector } from "../utils/createDeepEqualSelector";

import type { RootState } from "../store";

// state.user is never undefined in practice, but may be undefined
// in the jest testing environment
export const selectUser = (state: RootState) => state.user?.user;

export const isBusinessUser = createDeepEqualSelector(
  selectUser,
  (user) => !!(user?.org_role && user?.org_uuid),
);

export const businessPermissions = createDeepEqualSelector(
  selectUser,
  (user) => user?.business_permissions || [],
);

export const dualApprovalRequired = createDeepEqualSelector(
  selectUser,
  (user) => {
    if (user?.dual_approval_admin_exemption) return false;
    return user?.dual_approval_required || false;
  },
);

export const achDualApprovalRequired = createDeepEqualSelector(
  selectUser,
  (user) => {
    if (user?.dual_approval_admin_exemption) return false;
    return user?.ach_dual_approval_required || false;
  },
);

export const internationalWireDualApprovalRequired = createDeepEqualSelector(
  selectUser,
  (user) => {
    if (user?.dual_approval_admin_exemption) return false;
    return user?.international_wire_dual_approval_required || false;
  },
);
